import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { mutationKeyMap } from "@/features/query-client";

import { updateUser } from "../api";
import type {
  IApiErrorResponse,
  IUpdateUserVariables,
} from "../types";

type IUpdateUserMutationResponse = Awaited<ReturnType<typeof updateUser>>;

interface IUpdateUserMutationVariables {
  id: number;
  variables: IUpdateUserVariables;
}

export const useUpdateUserMutation = () => {
  return useMutation<
    IUpdateUserMutationResponse,
    AxiosError<IApiErrorResponse>,
    IUpdateUserMutationVariables
  >({
    mutationKey: mutationKeyMap.updateUser,
    mutationFn: async ({ id, variables }) => {
      return await updateUser(id, variables);
    },
  });
};
